import React, { useEffect, useState } from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import api from '../../api';
import { ActionDialog, Loading } from './ActionDialog';

export const PreClaimDialog = ({ patientId, onClose }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/patients/${patientId}/pre-claim-review`).then(r => setD(r.data)).catch(() => setD({ items: [] })); }, [patientId]);
  return (
    <ActionDialog title="Pre-Claim Review Checklist" onClose={onClose} testid="pre-claim-dialog">
      {!d ? <Loading /> : (
        <>
          <div className={`rounded-lg p-3 mb-3 text-sm font-medium ${d.readyToSubmit ? 'bg-green-50 text-green-800' : 'bg-amber-50 text-amber-800'}`} data-testid="pre-claim-summary">
            {d.readyToSubmit ? 'All documents in place: ready to submit for pre-claim review.' : `${d.ready} of ${d.total} items ready. Complete the items marked red before submitting.`}
          </div>
          <ul className="space-y-2">
            {d.items.map(i => (
              <li key={i.key} className="flex items-start gap-2 text-sm" data-testid={`pre-claim-${i.key}`}>
                {i.ok ? <CheckCircle2 className="w-5 h-5 text-green-600 shrink-0" /> : <XCircle className="w-5 h-5 text-red-500 shrink-0" />}
                <span>{i.label}{i.found != null ? <span className="text-gray-400"> ({i.found} on file)</span> : null}</span>
              </li>
            ))}
          </ul>
        </>
      )}
    </ActionDialog>
  );
};
